/**
 * FVローディングアニメーション
 * 白背景＋ロゴ → ①bg → ②MV → ③キャッチコピー → ④3点バッジ の順にフェードイン
 */
const fvLoading = () => {
  const loading = document.getElementById('js-loading');
  if (!loading) return;

  const bg         = document.querySelector('.js-fv-bg');
  const mv         = document.querySelector('.js-fv-mv');
  const title      = document.querySelector('.js-fv-title');
  const badgesWrap = document.querySelector('.m-fv__badges');
  const badgeItems = document.querySelectorAll('.js-fv-badge');

  const show = (el) => el?.classList.add('is-visible');

  // ①背景 + ローディング退場（同時スタート）
  setTimeout(() => {
    show(bg);
    loading.classList.add('is-hidden');
  }, 500);

  // ②キービジュアル
  setTimeout(() => show(mv), 900);

  // ③キャッチコピー
  setTimeout(() => show(title), 1300);

  // ④3つのポイント（親を先に表示してから各バッジを200ms時間差）
  setTimeout(() => show(badgesWrap), 1700);
  badgeItems.forEach((badge, i) => {
    setTimeout(() => show(badge), 1700 + i * 200);
  });

  // ローディング要素をDOMから除去（transition完了後）
  setTimeout(() => loading.remove(), 1200);
};

export { fvLoading };
